/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Pale_Finch_SingInputs */

const en_soft_pale_finch_sing = /** @type {(inputs: Soft_Pale_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose which attributes are available for filtering comments in this report.`)
};

const de_soft_pale_finch_sing = /** @type {(inputs: Soft_Pale_Finch_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie aus, welche Merkmale zum Filtern von Kommentaren in diesem Bericht verfügbar sind.`)
};

/**
* | output |
* | --- |
* | "Choose which attributes are available for filtering comments in this report." |
*
* @param {Soft_Pale_Finch_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_pale_finch_sing = /** @type {((inputs?: Soft_Pale_Finch_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Pale_Finch_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_pale_finch_sing(inputs)
	return de_soft_pale_finch_sing(inputs)
});